import React, { useState, useEffect } from 'react';
import { Modal, Button, Card, Row, Col, Table } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import AddProductionPlanModal from './AddProductionPlanModal';
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Loader from '../loader/Loader';
import { formatDate } from "../../utils/formatDate"
export default function IndividualOrderDetailsModal({ orderId, show, handleClose }) {
  const [listLoading, setListLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [addProductionPlan, setAddProductionPlan] = useState(false)
  useEffect(() => {
    if (show && orderId) {
      fetchOrderDetails(orderId);
    }
  }, [show, orderId]);
  const fetchOrderDetails = async (orderId) => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const response = await axios.get(`${config.API}/purchaseorder/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data) {
        setOrderDetails(response.data || []);
      } else {
        setOrderDetails([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err.message);
      setOrderDetails(null);
    } finally {
      setListLoading(false);
    }
  };

  const markReadyForInspection = async (orderId) => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const response = await axios.post(
        `${config.API}/manager/markreadyforinspection/${orderId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        toast.success(response.data.message || "Marked ready for inspection");
      }
    } catch (err) {
      console.error("Error marking ready:", err.message);
    } finally {
      setListLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered className='font_family'>
      <Modal.Header closeButton className='border-0'>
        <strong className='fs-4'>Individual Order Details</strong>
      </Modal.Header>
      {
        listLoading ? (
          <Loader />
        ) : (
          <Modal.Body>
            <Card className="mb-4 shadow-sm border-0" style={{ background: "#F5F8F9" }}>
              <Card.Body>
                <h5 className="fw-bold">PO Details</h5>
                <Row className="mb-2">
                  <Col md={4}><strong>PO Number:</strong> {orderDetails?.data?.po_number || "N/A"}</Col>
                  <Col md={4}><strong>Consignee:</strong> {orderDetails?.data?.consignee || "N/A"}</Col>
                  <Col md={4}><strong>Inspection Type:</strong>
                    <span className="text-decoration-underline">
                      {orderDetails?.data?.inspection_type || "N/A"}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}><strong>Delivery Date:</strong> {formatDate(orderDetails?.data?.delivery_date || "N/A")}</Col>
                  <Col md={4}><strong>PO Date:</strong> {formatDate(orderDetails?.data?.po_date || "N/A")}</Col>
                  <Col md={4}><strong>Tentative Inspection Date:</strong> {formatDate(orderDetails?.data?.tentative_inspection_date || "N/A")}</Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="mb-4 shadow-sm border-0" style={{ background: "#F5F8F9" }}>
              <Card.Body>
                <h5 className="fw-bold">Product Details</h5>
                {orderDetails?.list?.length > 0 ? (
                  orderDetails.list.map((item, index) => (
                    <Row key={index} className="mb-2">
                      <Col md={3}><strong>Product Name:</strong> {item.product_name || "N/A"}</Col>
                      <Col md={3}><strong>Quantity:</strong> {item.quantity || "N/A"}</Col>
                      <Col md={3}><strong>Delivery Date:</strong> {formatDate(item.delivery_date || "N/A")}</Col>
                      <Col md={3}><strong>Inspection Date:</strong> {formatDate(item.inspection_date || "N/A")}</Col>
                    </Row>
                  ))
                ) : (
                  <p>No products found.</p>
                )}
              </Card.Body>
            </Card>
            <h5 className="fw-bold mb-3">Production Plan</h5>
            <Table hover className="mb-0 table-borderless align-middle">
              <thead className="table-secondary">
                <tr>
                  <th>PRODUCT NAME</th>
                  <th>QTY PLANNED</th>
                  <th>QTY PRODUCED</th>
                  <th>QTY PENDING</th>
                  <th>QTY DELIVERED</th>
                  <th>MONTH</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails?.plan?.length > 0 ? (
                  orderDetails?.plan?.map((planItem, index) => {
                    const planned =
                      Number(planItem?.qty_pending || 0) +
                      Number(planItem?.qty_produced || 0);
                    return (
                      <tr key={index}>
                        <td>{planItem?.product?.name || "N/A"}</td>
                        <td>{planned || 0}</td>
                        <td>{planItem?.qty_produced || 0}</td>
                        <td>{planItem?.qty_pending || 0}</td>
                        <td>{planItem?.qty_delivered || 0}</td>
                        <td>{planItem?.month}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">No production plan found.</td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="d-flex justify-content-end gap-2 mt-5">
              <Button variant="dark" onClick={() => setAddProductionPlan(true)}>Adjust Production Plan</Button>
              <Button
                variant="dark"
                onClick={() => markReadyForInspection(orderDetails?.data?.id)}
              >
                Mark Ready for Inspection
              </Button>
            </div>
          </Modal.Body>
        )
      }
      <AddProductionPlanModal
        show={addProductionPlan}
        planId={orderId}
        handleClose={() => setAddProductionPlan(false)}
        refreshParent={IndividualOrderDetailsModal}
      />
    </Modal>
  );
}
